export default "__VITE_ASSET__e5111e9e__"